import withRoot from "../../../modules/withRoot" // --- Post bootstrap -----
import React from "react"
import AppFooter from "../../../modules/views/AppFooter"
import Questions from "../../../modules/views/Questions"
import AppAppBar from "../../../modules/views/AppAppBar"
import Typography from "../../../modules/components/Typography"

const questions = [
  "Dificultad para respirar",
  "Fiebre",
  "Tos",
  "Dolor de pecho",
  "Dolor de cabeza",
  "Pérdida de gusto",
  "Pérdida de olfato",
]

function StepOne() {
  const header = (
    <>
      <Typography variant="h5" align="center">
        Marca si has presentado alguno(s) de los siguientes síntomas en la
        <strong> última semana.</strong>
      </Typography>
      <Typography variant="subtitle1" align="center">
        (Puedes continuar sin seleccionar ninguno)
      </Typography>
    </>
  )

  return (
    <React.Fragment>
      <AppAppBar />
      <Questions
        questions={questions}
        header={header}
        step={1}
        next="/survey/steps/two/"
      />
      <AppFooter />
    </React.Fragment>
  )
}

export default withRoot(StepOne)
